//Include Both Helper File with needed methods

import { loginService, resetTokenService } from "../../../Services/AuthService";
import {
  apiError,
  loginSuccess,
  logoutUserSuccess,
  reset_login_flag,
  resetTokenFailure,
  resetTokenStart,
  resetTokenSuccess,
} from "./reducer";

export const loginUser = (user, history) => async (dispatch) => {
  // try {
  //   let response;
  //   if (process.env.REACT_APP_DEFAULTAUTH === "user") {
  //     response = postLogin({
  //       username: user.username,
  //       password: user.password,
  //     });

  //   }

  //   var data = await response;

  //   if (data) {
  //     console.log("data", JSON.stringify(data));
  //     sessionStorage.setItem("authUser", JSON.stringify(data));
  //     if (process.env.REACT_APP_DEFAULTAUTH === "user") {
  //       var finallogin = JSON.stringify(data);
  //       finallogin = JSON.parse(finallogin);
  //       data = finallogin.data;
  //  console.log("data final message", finallogin.message);
  //       console.log("login status",finallogin.success)
  //       // let finalloginsuccess=false;

  //       if (finallogin.success) {
  //         console.log("data", data);
  //         dispatch(loginSuccess(data));
  //         history("/dashboard");
  //       } else {
  //         dispatch(apiError(finallogin.message));
  //       }
  //     } else {
  //       dispatch(loginSuccess(data));
  //       history("/dashboard");
  //     }
  //   }
  // } catch (error) {
  //   dispatch(apiError(error));
  // }

  try {
    let response;

    if (process.env.REACT_APP_DEFAULTAUTH === "user") {
      response = await loginService({
        username: user.username,
        password: user.password,
      });
    }

    if (response) {
      if (response.success) {
        sessionStorage.setItem("authUser", JSON.stringify(response));
        dispatch(loginSuccess(response));
        history("/dashboard");
      } else {
        dispatch(apiError(response.message));
      }
    }
  } catch (error) {
    dispatch(apiError(error || "Something went wrong"));
  }
};

export const logoutUser = () => async (dispatch) => {
  try {
    sessionStorage.removeItem("authUser");
    if (process.env.REACT_APP_DEFAULTAUTH === "user") {
      dispatch(logoutUserSuccess(true));
    } else {
      dispatch(logoutUserSuccess(true));
    }
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const resetToken = () => async (dispatch) => {
  try {
    let response;
    const authUserRaw = JSON.parse(sessionStorage.getItem("authUser"));
    const refreshToken = authUserRaw?.data?.refreshToken;
    if (process.env.REACT_APP_DEFAULTAUTH === "user") {
      response = await resetTokenService({
        refreshToken: refreshToken,
      });
    }

    if (response) {
      if (response.accessToken) {
        dispatch(resetTokenSuccess(response));

        const oldAuthUser = JSON.parse(sessionStorage.getItem("authUser"));

        const updatedAuthUser = {
          ...oldAuthUser,
          data: {
            ...oldAuthUser.data,
            token: response.accessToken,
            refreshToken: response.refreshToken,
          },
        };

        sessionStorage.setItem("authUser", JSON.stringify(updatedAuthUser));

        return updatedAuthUser;
      } else {
        dispatch(resetTokenFailure(response.message));
      }
    }
  } catch (error) {
    dispatch(resetTokenFailure(error || "Something went wrong"));
  }
};

export const socialLogin = (type, history) => async (dispatch) => {};

export const resetLoginFlag = () => async (dispatch) => {
  try {
    const response = dispatch(reset_login_flag());
    return response;
  } catch (error) {
    dispatch(apiError(error));
  }
};
